export default __webpack_public_path__ + "static/media/classic_band.ccf65e79.png";